import { render, staticRenderFns } from "./PoliticasPrivacidad.vue?vue&type=template&id=11493bd7&"
import script from "./PoliticasPrivacidad.vue?vue&type=script&lang=js&"
export * from "./PoliticasPrivacidad.vue?vue&type=script&lang=js&"
import style0 from "./PoliticasPrivacidad.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports